import angular from 'angular';

import './api/orders';

angular.module('folkeuni').factory('Orders', function(OrdersApi, $q) {
  var orders = this;

  orders.getCurrentUsersOrder = function(){
    var deferred = $q.defer();

    OrdersApi.getCurrentUsersOrder().then(function(ordersObj){
      deferred.resolve(ordersObj.data);
    },function(errorResponse){
      deferred.reject(errorResponse);
    })

    return deferred.promise;
  }

  orders.getOrderByIdAndGuid = function(id,guid){
    var deferred = $q.defer();

    OrdersApi.getOrderByIdAndGuid(id,guid).then(function(orderObj){
        deferred.resolve(orderObj.data);
    },function(errorResponse){
      deferred.reject(errorResponse);
    })

    return deferred.promise;
  }
  return orders;
});
